module.exports = __webpack_public_path__ + "img/yaourtvert_on.f7352289.gif";